module.exports = __webpack_public_path__ + "static/img/image-0.0b07897e.png";